import React from 'react';
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';
import { useAppDispatch } from 'application/providers/StoreProvider';
import { setCaptchaToken as setCaptchaTokenAction } from 'application/store';
import { ZVUK_CAPCHA_API_KEY } from 'application/consts';
import { YandexCaptchaProps } from './types';
import useYandexCaptchaController from './useYandexCaptchaController';

export const YandexCaptcha = ({
  isVisible,
  setIsVisible,
  setCaptchaStatus,
  successCallback,
  yandexErrorCallback,
  captchaKey,
  resetCaptcha,
}: YandexCaptchaProps) => {
  const clientKey = ZVUK_CAPCHA_API_KEY;

  const dispatch = useAppDispatch();

  const {
    handleChallengeHidden,
    handleChallengeVisible,
    handleJavaScriptError,
    handleNetworkError,
    handleSuccess,
    handleTokenExpired,
  } = useYandexCaptchaController({
    setCaptchaToken: (token: string | null) => dispatch(setCaptchaTokenAction(token)),
    setIsVisible,
    setCaptchaStatus,
    successCallback,
    yandexErrorCallback,
    resetCaptcha,
  });

  if (!clientKey) {
    return null;
  }

  return (
    <InvisibleSmartCaptcha
      sitekey={clientKey}
      onSuccess={handleSuccess}
      onChallengeHidden={handleChallengeHidden}
      visible={isVisible}
      onChallengeVisible={handleChallengeVisible}
      onNetworkError={handleNetworkError}
      onJavascriptError={handleJavaScriptError}
      onTokenExpired={handleTokenExpired}
      hideShield
      key={captchaKey}
    />
  );
};
